module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [(_vm.showCategoryFilter) ? _c('el-col', {
    attrs: {
      "span": _vm.showTextFilter ? 10 : 20
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Category",
      "size": "mini"
    },
    model: {
      value: (_vm.computedCategory),
      callback: function($$v) {
        _vm.computedCategory = $$v
      },
      expression: "computedCategory"
    }
  }, _vm._l((_vm.categoryList), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.title,
        "value": category.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showTextFilter) ? _c('el-col', {
    attrs: {
      "span": _vm.showCategoryFilter ? 10 : 20
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "Search",
      "prefix-icon": "el-icon-search",
      "size": "mini"
    },
    model: {
      value: (_vm.computedSearchText),
      callback: function($$v) {
        _vm.computedSearchText = $$v
      },
      expression: "computedSearchText"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.canAdd) ? _c('el-tooltip', {
    attrs: {
      "content": ("Add new " + _vm.itemName)
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle filter-btn filter-add",
    on: {
      "click": _vm.handleCreate
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Clear filters"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle filter-btn filter-clear",
    on: {
      "click": _vm.handleResetFilters
    }
  })])], 1)])], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('draggable', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.handleLoadMore),
      expression: "handleLoadMore"
    }],
    staticClass: "draggable-group",
    class: {
      'draggable-fixed': _vm.isFixed
    },
    attrs: {
      "draggable": ".draggable",
      "body-style": {
        padding: '0'
      },
      "group": {
        name: _vm.draggableGroup,
        pull: 'clone',
        put: false
      },
      "id": _vm.draggableId,
      "sort": false
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, [_vm._l((_vm.computedValue), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        draggable: !_vm.isDisabled(item.id) && _vm.isEditable,
          enabled: !_vm.isDisabled(item.id),
          disabled: _vm.isDisabled(item.id),
      }
    }, [_c('el-card', {
      key: item.id,
      class: {
        selected: item.id === _vm.selectedId, 'is-global': item.isGlobal || false
      },
      staticStyle: {
        "margin": "4px 0"
      },
      attrs: {
        "shadow": "never",
        "body-style": _vm.itemStyle(item.id)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelect(item)
        },
        "dblclick": function($event) {
          return _vm.handleAddItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "handle pull-right"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ellipsis-v"
    })]), _vm._v(" "), (item.isEditable || false) ? _c('div', {
      staticClass: "options pull-right"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.handleEditItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])], 1)
  }), _vm._v(" "), (_vm.computedValue.length === 0) ? _c('empty', [_vm._v("No " + _vm._s(_vm.itemNamePlural) + " found.")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f404b2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/Selector.vue
// module id = 3277
// module chunks = 3